module.exports = __webpack_public_path__ + "static/machineImg-a06ac43ab6bb7e4f15d1fb8a09096bde.jpg";